import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get_Api } from "../API_URL";

function ReportDetail() {
    const { id } = useParams();
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchReport = async () => {
        try {
            setLoading(true);
            const response = await Get_Api(`api/admin/GetAReport/${id}`);
            setReport(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport();
    }, [id]);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-20">
                <div className="w-12 h-12 border-4 border-blue-500 border-dashed rounded-full animate-spin mb-4"></div>
                <p className="text-gray-600 font-medium">Loading Report...</p>
            </div>
        );
    }

    if (!report) {
        return (
            <div className="text-center py-10 text-gray-500 font-medium">
                No Report Found
            </div>
        );
    }

    return (
        <section className="relative overflow-hidden mt-[80px] lg:mt-[80px]">
            <div className="max-w-5xl mx-auto p-4 md:p-8">
                {report?.Image && (
                    <img
                        src={report?.Image}
                        alt="Report"
                        className="w-full rounded-lg mb-6 shadow-md object-cover h-[180px] sm:h-[220px] md:h-[280px] lg:h-[320px]"
                    />
                )}

                {/* <h1 className="text-3xl font-neue font-bold text-gray-900 mb-3">
                    {report?.Title}
                </h1> */}
                <p className="font-[500] text-[17px] leading-[27px] font-neue font-bold text-gray-900 mb-3">
                    {report?.Title}
                </p>

                <div className="flex items-center text-sm text-gray-600 mb-6">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-neue font-semibold">
                        {report?.Category}
                    </span>
                    <span className="ml-4 font-neue text-gray-400">
                        {new Date(report?.createdAt)?.toLocaleDateString()}
                    </span>
                </div>

                <div className="flex flex-wrap gap-2 mb-6">
                    {report?.Tags?.map((tag, i) => (
                        <span
                            key={i}
                            className="bg-gray-200 font-neue text-gray-700 px-3 py-1 rounded-full text-xs"
                        >
                            #{tag}
                        </span>
                    ))}
                </div>
                <div
                    className="prose max-w-none prose-lg font-neue html-content"
                    dangerouslySetInnerHTML={{ __html: report?.Content }}
                />
            </div>
        </section>
    );
}

export default ReportDetail;
